"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _Text = _interopRequireDefault(require("../Text"));

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var shine = (0, _core.keyframes)({
  '0%': {
    transform: 'skewX(-45deg) translateX(-100%)'
  },
  '20%': {
    transform: 'skewX(-45deg) translateX(100%)'
  },
  '100%': {
    transform: 'skewX(-45deg) translateX(100%)'
  }
});

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing,
      colors = _useTheme.colors;

  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      padding: spacing(0, 1),
      borderRadius: spacing(2),
      backgroundColor: colors.secondary,
      position: 'relative',
      overflow: 'hidden',
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 2,
        background: "linear-gradient(\n          to right,\n          ".concat(colors.white, ",\n          ").concat(colors.white, " 60px,\n          transparent 60px\n        )"),
        opacity: 0.3,
        height: '100%',
        width: '100%',
        transformOrigin: 'left bottom',
        animation: "".concat(shine, " 2s ease-in infinite")
      }
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing, colors }}", function () {
  return [_useTheme2["default"]];
});

var NewFeatureChip = function NewFeatureChip(props) {
  var children = props.children,
      className = props.className,
      style = props.style;
  var classes = useStyles();
  return (0, _core.jsx)("div", {
    css: classes.root,
    className: className,
    style: style
  }, (0, _core.jsx)(_Text["default"], {
    variant: "tertiary"
  }, children));
};

__signature__(NewFeatureChip, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = NewFeatureChip;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(shine, "shine", "/builds/bA1zbJom/0/gojob/ui-bits/src/NewFeatureChip/index.tsx");
  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/NewFeatureChip/index.tsx");
  reactHotLoader.register(NewFeatureChip, "NewFeatureChip", "/builds/bA1zbJom/0/gojob/ui-bits/src/NewFeatureChip/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/NewFeatureChip/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();